export default {
  meta: {
    title: '销售合同'
  }
};
